// Skeleton placeholder for the lifecycle trend panel. Mirrors the live
// chart layout so the page doesn't shift when data lands.

import { cn } from "@shared/lib";

import { LIFECYCLE_TREND_STRINGS } from "../lib/strings";

export interface LifecycleTrendSkeletonProps {
  loadingLabel?: string;
  className?: string;
}

export function LifecycleTrendSkeleton({
  loadingLabel = LIFECYCLE_TREND_STRINGS.title,
  className,
}: LifecycleTrendSkeletonProps) {
  return (
    <section
      aria-busy="true"
      aria-label={loadingLabel}
      className={cn("flex animate-pulse flex-col gap-3", className)}
    >
      <div className="h-4 w-40 rounded bg-muted" />
      <div className="h-3 w-56 rounded bg-muted" />
      <div className="h-60 rounded-lg border bg-muted/40" />
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="h-3 w-16 rounded bg-muted" />
        ))}
      </div>
    </section>
  );
}
